<template>
  <div class="d-cal__subjects no-print"
       @pointerenter="onMouseEnter"
       @pointerleave="onMouseLeave"
       :class="{'d-cal__subjects--dragging': isDraggingSubject}">
    <transition name="fadeIn">
      <div v-if="deleteSubject"
           class="d-cal__subjects--trashcan"
           :class="{'d-cal__subjects--trashcan--hovered': isDCalATrashcan}">
        <div class="icon-bin"></div>
        <p>{{ $t('vue2.common.delete') }} {{ deleteSubject.title }}</p>
      </div>
    </transition>
    <CreateSubject
      :calendarId="calendarId"
      :isInDCalendar="true">
    </CreateSubject>
    <div class="d-cal__subjects__container">
      <ImportSubjectsToKlass :calendarId="calendarId" v-if="isShowImportSubjectsOption"></ImportSubjectsToKlass>
      <Loader class="d-cal__subjects__container__loader" bg-color="#f6f9fc" v-if="isSubjectsLoading"></Loader>
      <ul class="d-acc">
        <li class="d-acc__container"
            :class="{'d-acc__container--closed': theActiveAcc !== subjectsCat.type}"
            @click.stop="setTheActiveAcc(subjectsCat.type)"
            :key="subjectsCat.type"
            v-for="subjectsCat in subjectsInCategoriesSorted">
          <h4>{{ subjectsCat.v_title }}</h4>
          <transition name="accordion"
                      @enter="startTrans"
                      @after-enter="endTrans"
                      @before-leave="startTrans"
                      @after-leave="endTrans">
            <div v-if="theActiveAcc === subjectsCat.type">
              <!-- <ul class="d-acc__container__body"> -->
              <transition-group name="list-complete" class="d-acc__container__body" tag="ul">
                <li class="list-complete-item d-cal__subjects__subject"
                    v-for="subject in activeSubjects"
                    :class="{'d-cal__subjects__subject--not-editable': !subject.v_is_editable}"
                    :style="[
              {'borderColor': subject.color},
              {'backgroundColor': subject.color}
              ]"
                    :subject="subject"
                    :key="subject.id"
                    :content="tippyContent(subject)"
                    v-tippy="tippySettings(subject)"
                    draggable="false"
                    @dragstart.prevent
                    @click.prevent.stop
                    @pointerdown.prevent="onMouseDown(subject, $event)">
                  <div class="d-cal__subjects__subject__left">
                    {{ subject.title }}
                  </div>
                  <div class="d-cal__subjects__subject__right">
                    <div class="subject-draggable__slider"
                         v-if="subject.v_must_have_teacher && subject.v_cal_types.users.length < 1">
                      <div class="d-cal__subjects__subject__subject_info">
                        {{ subject.v_hours }}{{ i18n[locale]['hours_per_year'] }}
                      </div>
                      <div class="d-cal__subjects__subject__remember-teacher">
                        <span class="icon-user3"></span>{{ i18n[locale]['add'] }}
                      </div>
                    </div>
                    <div class="d-cal__subjects__subject__subject_info" v-else>
                      <template v-if="subject.v_hours">{{ subject.v_hours }}{{
                          i18n[locale]['hours_per_year']
                        }}
                      </template>
                    </div>
                  </div>
                  <div class="subject__details">
                    <span class="icon-location" v-if="subject.v_cal_types.rooms.length > 0"></span>
                    <span class="icon-user" v-if="subject.v_cal_types.users.length > 0"></span>
                  </div>
                </li>
                <!-- </ul> -->
              </transition-group>
            </div>
          </transition>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import CreateSubject from '../Subjects/CreateSubject.vue'
import Loader from '../common/Loader.vue'
import ImportSubjectsToKlass from '../Subjects/ImportSubjectsToKlass'

const SUBJETS_ALL_TYPES = {
  subject: {
    da: {
      name: 'Fag',
      order: 1
    },
    en: {
      name: 'Subject',
      order: 1
    },
    nb: {
      name: 'Fag',
      order: 1
    }
  },
  optional: {
    da: {
      name: 'Valgfag/Hold',
      order: 2
    },
    en: {
      name: 'Optional grades/groups',
      order: 2
    },
    nb: {
      name: 'Valgfag/gruppe',
      order: 2
    }
  },
  supplemental: {
    da: {
      name: 'UUV',
      order: 6
    },
    en: {
      name: 'UUV',
      order: 6
    },
    nb: {
      name: 'UUV',
      order: 6
    }
  },
  frame: {
    da: {
      name: 'Temavisning',
      order: 3
    },
    en: {
      name: 'Theme',
      order: 3
    },
    nb: {
      name: 'Temavisning',
      order: 3
    }
  },
  break: {
    da: {
      name: 'Pause',
      order: 7
    },
    en: {name: 'Break', order: 7},
    nb: {
      name: 'Pause',
      order: 7
    }
  },
  resource: {
    da: {
      name: 'Ressource (skjult)',
      order: 4
    },
    en: {
      name: 'Resource (hidden)',
      order: 4
    },
    nb: {
      name: 'Ressurs (skjult)',
      order: 4
    }
  },
  person_resource: {
    da: {
      name: 'Ressource (skjult)',
      order: 4
    },
    en: {
      name: 'Resource (hidden)',
      order: 4
    },
    nb: {
      name: 'Ressurs (skjult)',
      order: 4
    }
  },
  other_tasks: {
    da: {
      name: 'Anden tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
      order: 13
    },
    en: {name: 'Other tasks', order: 13},
    nb: {name: 'Annen tid', order: 13}
  },
  other_stuff: {
    da: {
      name: 'Øvrig tid <span class="pill pill--grey hint--top-right hint--medium" aria-label="Udfases fra skoleåret 21/22 pga. den nye arbejdstidsaftale (A20)">udfases</span>',
      order: 12
    },
    en: {
      name: 'Additional tasks',
      order: 12
    },
    nb: {
      name: 'Øvrig tid',
      order: 12
    }
  },
  available: {
    da: {
      name: 'Rådighedstime',
      order: 11
    },
    en: {
      name: 'On-Call',
      order: 11
    }
  },
  person_resource_visible: {
    da: {
      name: 'Ressource (synlig)',
      order: 5
    },
    en: {
      name: 'Resource (Visible)',
      order: 5
    },
    nb: {
      name: 'Ressurs (Vises for elever)',
      order: 5
    }
  },
  club: {
    da: {
      name: 'SFO tid',
      order: 8
    },
    en: {name: 'SFO time', order: 8},
    nb: {name: 'SFO tid', order: 8}
  },
  additional_tasks: {
    da: {
      name: 'Øvrige opgaver',
      order: 9
    },
    en: {name: 'Not teaching', order: 9},
    nb: {name: 'Øvrige oppgaver', order: 9}
  },
  pool: {
    da: {
      name: 'Lokalpulje',
      order: 9
    }
  },
  preparation: {
    da: {
      name: 'Forberedelse',
      order: 10
    },
    en: {
      name: 'Preparation',
      order: 10
    },
    nb: {
      name: 'Forberedelse',
      order: 10
    }
  },
  reservation: {
    da: {
      name: 'Reservation',
      order: 11
    },
    en: {
      name: 'Reservation',
      order: 11
    },
    nb: {
      name: 'Reservasjon',
      order: 11
    }
  },
  activity: {
    da: {
      name: 'Aktiviteter',
      order: 11
    },
    en: {
      name: 'Activities',
      order: 11
    },
    nb: {
      name: 'Aktiviteter',
      order: 11
    }
  },
  absence: {
    da: {
      name: 'Fravær',
      order: 12
    },
    en: {
      name: 'Absence',
      order: 12
    },
    nb: {
      name: 'Fravær',
      order: 12
    }
  },
  exercise: {
    da: {
      name: 'Bevægelse',
      order: 21
    }
  },
  flextime: {
    da: {
      name: 'Flextid',
      order: 22
    }
  },
  pay_supplement: {
    da: {
      name: 'Tillæg',
      order: 13
    }
  },
  without_kids: {
    da: {
      name: 'Uden børn',
      order: 2
    }
  },
  with_kids: {
    da: {
      name: 'Med børn',
      order: 1
    }
  }
}
const SUBJECTS_TYPE_WITH_REMEMBER_TEACHER = {
  subject: true,
  resource: true,
  optional: true,
  exercise: true,
  club: true,
  supplemental: true
}
// Det reducerede per-klasse timetal (subject_calendars.hours) vises kun for dette
// skoleår. Øvrige skoleår viser fagets grundtimetal (subject.hours) som hidtil.
const SCHOOL_YEAR_WITH_REDUCED_HOURS = '2026-2027'
const I18N = {
  da: {
    cant_edit: 'Kan ikke redigeres fra kalenderen',
    hours_per_year: 't/år',
    add: 'Tilføj'
  },
  en: {
    cant_edit: 'Can not edit from the calendar',
    hours_per_year: 'h/year',
    add: 'Add'
  },
  nb: {
    cant_edit: 'Kan ikke redigeres fra kalenderen',
    hours_per_year: 't/år',
    add: 'Legg til'
  }
}
export default {
  components: {ImportSubjectsToKlass, Loader, CreateSubject},
  props: {
    calendarId: {
      default: 7
    },
    dragActiveDate: {
      type: Object,
      default: () => null
    },
    locale: {
      default: 'en'
    },
    school: {
      default: null
    },
    deleteSubject: {
      default: null
    }
  },
  data () {
    return {
      startX: 0,
      startY: 0,
      startClientY: 0,
      startClientX: 0,
      delta: 5,
      activeSubject: null,
      movedY: 0,
      movedX: 0,
      activeSubjectBCR: null,
      theActiveAcc: null,
      accTransition: null,
      isDraggingSubject: false,
      isDCalATrashcan: false
    }
  },
  computed: {
    schoolId () {
      return this.$store.getters.schoolId
    },
    isReducedHoursSchoolYear () {
      const year = this.$store.state.localActivatedSchoolYear
      return !!year && year.name === SCHOOL_YEAR_WITH_REDUCED_HOURS
    },
    theUser () {
      return this.$store.state.user
    },
    i18n () {
      return I18N
    },
    localPoolTitle () {
      const title = this.$store.getters.localPoolTitle
      return title || this.$t('vue2.task_overview.pool')
    },
    isShowImportSubjectsOption () {
      const schoolCountry = this.school && this.school.country ? this.school && this.school.country.toLowerCase() : 'da'
      return this.subjects.length < 1 && this.allKlassCalendarsInAHash[this.calendarId] && (schoolCountry === 'no' || schoolCountry === 'dk')
    },
    allCalendarsInHash () {
      return this.$store.getters.allCalendarsInHash
    },
    calendarType () {
      return this.allCalendarsInHash[this.calendarId] ? this.allCalendarsInHash[this.calendarId].type : ''
    },
    allKlassCalendarsInAHash () {
      return this.$store.getters.allKlassCalendarsInHash
    },
    subjects () {
      return this.$store.state.calendar.subjects
    },
    isSubjectsLoading () {
      return this.$store.state.calendar.isSubjectsLoading
    },
    theActiveAccSubjects () {
      return this.allSubjects.filter(subject => subject.subject_type === this.theActiveAcc)
    },
    isPermissionsActivatedForSchool () {
      return this.$store.getters.isPermissionsActivatedForSchool
    },
    userPermissions () {
      return this.$store.getters.userPermissions
    },
    theUserIsAdmin () {
      return this.userHasPermission('can_manage_school')
    },
    isPermissionToSeeAbsence () {
      if (this.schoolId !== 29045) {
        return true
      } else {
        return this.theUserIsAdmin
      }
    },
    filteredSubjects () {
      return this.subjects.filter(subject => {
        if (this.isPermissionToSeeAbsence) {
          return subject
        } else {
          return subject.subject_type !== 'absence'
        }
      })
    },
    allSubjects () {
      let sortedSubjects = this.filteredSubjects.sort((a, b) => {
        if (a.name && b.name) {
          return a.name.localeCompare(b.name, undefined, {
            numeric: true,
            sensitivity: 'base'
          })
        }
      })
      return sortedSubjects.map(subject => {
        // events uses title not name
        let title = subject.calendar_id === (this.calendarId * 1) ? subject.name : subject.name + ', ' + subject.calendar_name
        this.$set(subject, 'title', title)
        if (subject.subject_type === 'absence' || subject.subject_type === 'flexin' || subject.subject_type === 'flexout') {
          this.$set(subject, 'v_is_editable', false)
          this.$set(subject, 'v_hours', '')
          this.$set(subject, 'v_other_school', false)
          this.$set(subject, 'v_cal_types', this.getCalUsers(subject))
        } else {
          // Brug det per-klasse timetal fra subject_calendars (matcher denne kalender),
          // ellers fald tilbage til fagets grundtimetal (subject.hours).
          let plannedHours = this.calendarSubjectHours(subject)
          let hours = subject.actual_hours ? plannedHours - Math.floor(subject.actual_hours) : plannedHours * 1
          this.$set(subject, 'v_hours', hours.toFixed(0))
          this.$set(subject, 'v_other_school', false)
          this.$set(subject, 'v_is_editable', true)
          this.$set(subject, 'v_cal_types', this.getCalUsers(subject))
        }
        if (SUBJECTS_TYPE_WITH_REMEMBER_TEACHER[subject.subject_type] && this.calendarType !== 'user') {
          subject.v_must_have_teacher = true
        }
        return subject
      })
    },
    subjectsInCategories () {
      let subjectsAcc = []
      this.allSubjects.forEach(subject => {
        let idx = subjectsAcc.findIndex(subjectAcc => subjectAcc.type === subject.subject_type)
        if (idx < 0) {
          subjectsAcc.push({type: subject.subject_type, subjects: [subject]})
        } else {
          subjectsAcc[idx].subjects.push(subject)
        }
      })
      return subjectsAcc
    },
    subjectsInCategoriesSorted () {
      return this.subjectsInCategories.map(subCat => {
        let name = subCat.type
        let order = 100
        if (SUBJETS_ALL_TYPES[subCat.type]) {
          const localized = SUBJETS_ALL_TYPES[subCat.type][this.locale] ? SUBJETS_ALL_TYPES[subCat.type][this.locale] : SUBJETS_ALL_TYPES[subCat.type]['da']
          name = localized.name
          order = localized.order
        }
        if (subCat.type === 'pool') {
          name = this.localPoolTitle
        }
        subCat.v_order = order
        subCat.v_title = name
        return subCat
      }).sort((a, b) => (a.v_order > b.v_order) ? 1 : -1)
    },
    activeSubjects () {
      const activeSubjects = this.subjectsInCategoriesSorted.filter(subjectsGroup => subjectsGroup.type === this.theActiveAcc)
      return activeSubjects && activeSubjects[0] && activeSubjects[0].subjects ? activeSubjects[0].subjects : []
    }
  },
  watch: {
    calendarId (val) {
      if (val) {
        const isNewCalendar = true
        this.$store.dispatch('readCalendarSubjects', isNewCalendar)
      }
    },
    deleteSubject (val) {
      if (!val) {
        this.isDCalATrashcan = false
      }
    }
  },
  methods: {
    calendarSubjectHours (subject) {
      if (this.isReducedHoursSchoolYear && Array.isArray(subject.subject_calendars)) {
        const match = subject.subject_calendars.find(sc => sc.calendar_id === (this.calendarId * 1))
        if (match && match.hours !== null && match.hours !== undefined && match.hours !== '') {
          const parsed = parseFloat(match.hours)
          if (!isNaN(parsed)) {
            return parsed
          }
        }
      }
      // Fallback: returnér det rå subject.hours, så regnestykket i allSubjects
      // forbliver identisk med den oprindelige adfærd for øvrige skoleår.
      return subject.hours
    },
    userHasPermission (permission) {
      if (!this.theUser) {
        return false
      }
      if (this.isPermissionsActivatedForSchool) {
        return this.userPermissions.indexOf(permission) > -1 || this.theUser.admin
      } else {
        return true
      }
    },
    onMouseEnter (evt) {
      if (!this.deleteSubject) {
        return
      }
      this.isDCalATrashcan = true
      this.$emit('onMouseEnter')
    },
    onMouseLeave (evt) {
      this.isDCalATrashcan = false
      if (!this.deleteSubject) {
        return
      }
      this.$emit('onMouseLeave')
    },
    startTrans (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTrans (el) {
      el.style.height = ''
    },
    tippyContent (subject) {
      if (!subject.v_is_editable) {
        return this.i18n[this.locale]['cant_edit']
      } else {
        return subject.v_cal_types.toolTipText
      }
    },
    tippySettings (subject) {
      if (!subject.v_is_editable) {
        return {
          trigger: 'click',
          arrow: true,
          onShow: this.hideTippy,
          zIndex: '999999992',
          boundary: 'window'
        }
      } else {
        return {
          arrow: true,
          zIndex: '999999992',
          boundary: 'window',
          onShow: () => subject.v_cal_types.toolTipText.length > 0
        }
      }
    },
    getCalUsers (subject) {
      let users = []
      let rooms = []
      if (subject.cals) {
        subject.cals.forEach(cal => {
          switch (cal.calendar_type) {
            case 'user':
              // code block
              users.push(cal.name)
              break
            case 'room':
              rooms.push(cal.name)
              break
          }
        })
      }
      return {users: users, rooms: rooms, toolTipText: users.concat(rooms).join(', ')}
    },
    setTheActiveAcc (subjectType) {
      const key = 'd_subject_acc_' + this.calendarId
      if (this.theActiveAcc === subjectType) {
        this.theActiveAcc = null
        if (this.$helpers.getCookie(key)) {
          this.$helpers.deleteCookie(key)
        }
      } else {
        this.theActiveAcc = subjectType
        if (subjectType !== 'absence') {
          this.$helpers.setCookie(key, subjectType)
        }
      }
    },
    onMouseDown (subject, evt) {
      // return if right clicks on mouse
      if (evt.button !== 0) {
        return
      }
      const el = evt.target.closest('li')
      this.activeSubjectBCR = el.getBoundingClientRect()
      this.$emit('setDragLesson', subject)
      this.$emit('setActiveSubjectBCR', el.getBoundingClientRect())
      // find out where the Subject is clicked
      this.activeSubject = subject
      this.startX = evt.pageX
      this.startY = evt.pageY
      this.startClientY = evt.clientY
      this.startClientX = evt.clientX
      evt.target.releasePointerCapture(evt.pointerId)
      document.addEventListener('pointermove', this.onMouseMove)
      document.addEventListener('pointerup', this.onMouseUp)
    },
    onMouseUp (evt) {
      this.getIsDragOrClick(evt)
      document.removeEventListener('pointermove', this.onMouseMove)
      document.removeEventListener('pointerup', this.onMouseUp)
      this.cleanUp()
      this.$emit('doMouseUp')
    },
    getIsDragOrClick (event) {
      if (!this.isDraggingSubject) {
        if (this.activeSubject.v_is_editable) {
          this.$store.commit('setEditSubject', this.activeSubject)
        }
      }
    },
    onMouseMove (evt) {
      this.movedY = evt.pageY - (this.startClientY - this.activeSubjectBCR.top)
      this.movedX = evt.pageX - (this.startClientX - this.activeSubjectBCR.left)
      this.$emit('movedXY', this.movedX, this.movedY)
      if (!this.isDraggingSubject) {
        this.setIsDraggingSubject(true)
      }
      this.$emit('movedXY', this.movedX, this.movedY)
    },
    setIsDraggingSubject (boolean) {
      if (boolean) {
        this.isDraggingSubject = true
        const subjectObj = {
          calendarId: this.activeSubject.calendar_id,
          subjectId: this.activeSubject.id
        }
        this.$store.dispatch('readSubjectAvailability', subjectObj)
      } else {
        this.isDraggingSubject = false
      }
    },
    cleanUp () {
      this.setIsDraggingSubject(false)
      this.activeSubject = null
      this.$emit('movedXY', null, null)
      this.$emit('setIsDraggingExternalEvent', false)
      this.$store.dispatch('clearAvailability')
      let el = this.$refs.d_cal_dragged
      if (el) {
        el.remove()
      }
    }
  },
  beforeMount () {
    const key = 'd_subject_acc_' + this.calendarId
    if (this.$helpers.getCookie(key)) {
      this.setTheActiveAcc(this.$helpers.getCookie(key))
    }
  },
  mounted () {
    this.$store.dispatch('readCalendarSubjects')
  }
}
</script>

<style scoped>
@import "../../assets/css/variables.css";

.d-acc {
  user-select: none;
  box-shadow: rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, .12) 0px 1px 1px 0px, rgba(64, 68, 82, .16) 0px 0px 0px 1px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(0, 0, 0, 0) 0px 0px 0px 0px, rgba(64, 68, 82, .08) 0px 2px 5px 0px;
  border-radius: 4px;
}

.d-acc .d-acc__container:first-child:not(:only-child) h4 {
  border-radius: 4px 4px 0 0;
  border-top: 0;
}

.d-acc .d-acc__container:last-child:not(:only-child) h4 {
  border-radius: 0 0 4px 4px;
}

.d-acc .d-acc__container:only-child,
.d-acc .d-acc__container:only-child h4 {
  border-radius: 4px;
  border-top: 0;
}

.d-acc__container h4 {
  position: relative;
  display: block;
  cursor: pointer;
  background: #fff;
  border-top: 1px solid #d8d8d8;
  padding: 0.5rem 1rem;
  transition: background-color 0.15s;
}

.d-acc__container h4:hover {
  background: #f5f6f8;
}

.d-acc__container h4:before,
.d-acc__container h4:after {
  position: absolute;
  top: 50%;
  transform: translateY(-50%) rotate(315deg);
  right: 10px;
  content: '';
  width: 2px;
  height: 5px;
  background-color: #989899;
  border-radius: 2px;
}

.d-acc__container h4:after {
  top: 50%;
  right: 13px;
  transform: translateY(-50%) rotate(230deg);
}

.d-acc__container.d-acc__container--closed h4:before {
  transform: translateY(-50%) rotate(45deg);
}

.d-acc__container.d-acc__container--closed h4:after {
  transform: translateY(-50%) rotate(-45deg);
}

.d-acc__container__body {
  background: #ffffff;
  padding: 0 10px 0 5px;
  transition: 0.3s ease all;
  max-height: 50vh;
  overflow-y: auto;
  overflow-x: hidden;
  margin: 0;
  border-top: 1px solid #E2E2E2;
}

.d-acc__container:not(.d-acc__container--closed) .d-acc__container__body {
  padding: 10px 10px 10px 5px;
}

.d-acc__container--closed .d-acc__container__body {
  max-height: 0;
}

.d-cal__subjects {
  --borderColor: #d9d9d9;
}

.d-cal__subjects {
  width: 230px;
  padding: 1rem;
  border-right: 1px solid var(--borderColor);
  position: relative;
  background: #f6f9fc;
}

.d-cal__subjects.d-cal__subjects--dragging {
  pointer-events: none;
}

.d-cal__subjects--trashcan {
  transition: all 0.25s;
  color: #f87071;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  font-style: italic;
  bottom: 0;
  padding-top: 165px;
  background-color: #ffffff;
  z-index: 1231231;
  text-align: center;
  border: 2px solid transparent;
  opacity: 0.9;
}

.d-cal__subjects--trashcan.d-cal__subjects--trashcan--hovered {
  opacity: 1;
  background: #fef1f2;
}

.d-cal__subjects--trashcan > * {
  opacity: 0.5;
}

.d-cal__subjects--trashcan.d-cal__subjects--trashcan--hovered > * {
  opacity: 1;
}

.d-cal__subjects--trashcan div {
  font-size: 40px;
  transition: transform 0.25s;
  margin-bottom: 0.5rem;
}

.d-cal__subjects--trashcan.d-cal__subjects--trashcan--hovered div {
  transform: translateY(-0.5rem);
}

.d-cal__subjects--trashcan:after {
  transition: all 0.25s;
  content: '';
  z-index: 1231;
  display: flex;
  color: #f87071;
  position: absolute;
  top: 1rem;
  left: 1rem;
  right: 1rem;
  bottom: 1rem;
  border: 2px dashed #f87071;
  border-radius: 4px;
  opacity: 0.5;
}

.d-cal__subjects--trashcan.d-cal__subjects--trashcan--hovered:after {
  opacity: 1;
}

.d-cal__subjects--trashcan.d-cal__subjects--trashcan--hovered:after {
  border: 2px solid #f87071;
  padding-top: 8rem;
}

.d-cal__subjects__container {
  position: relative;
}

.d-cal__subjects__container__loader {
  position: absolute;
  top: 20px;
  left: 0;
  right: 0;
}

.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}

.list-complete-enter, .list-complete-leave-to
  /* .list-complete-leave-active below version 2.1.8 */
{
  opacity: 0;
  transform: translateY(30px);
}

.list-complete-leave-active {
  position: absolute;
}

.d-cal__subjects__subject {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 0.5rem;
  min-height: 40px;
  color: #ffffff !important;
  border-radius: 2px;
  background: transparent;
  overflow: hidden;
  box-shadow: 1px 1px 5px rgba(0, 0, 0, .3);
  text-align: left;
  margin: 0 0 1rem 0;
  min-width: auto;
  font-weight: bold;
  transition: all 0.25s;
  animation: fadeIn;
  cursor: pointer;
  line-height: 1em;
  border-left: 4px solid transparent;
  touch-action: none;
}

.d-cal__subjects__subject:before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(255, 255, 255, 0.2);
  z-index: 0;
}

.d-cal__subjects__subject__left {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 105px;
  min-width: 105px;
  overflow: hidden;
  text-overflow: ellipsis;
}


.d-cal__subjects__subject__right {
  display: flex;
  overflow: hidden;
  line-height: 11px;
  font-size: 11px;
}

.d-cal__subjects__subject__subject_info {
  text-align: right;
  opacity: 0.7;
}

.subject-draggable__slider {
  display: flex;
  flex-direction: column;
  height: 20px;
  transform: translateY(0px);
  transition: transform .3s;
}

.d-cal__subjects__subject:hover .d-cal__subjects__subject__right > .subject-draggable__slider {
  transform: translateY(-20px);
}

.d-cal__subjects__subject__right > .subject-draggable__slider > div {
  flex: 0 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
}

.d-cal__subjects__subject:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 10px 1px rgb(0 0 0 / 14%), 0 3px 14px 2px rgb(0 0 0 / 12%), 0 5px 5px -3px rgb(0 0 0 / 30%);
}

.d-cal__subjects__subject--not-editable {
  cursor: move !important;
}

.subject__details {
  position: absolute;
  top: 3px;
  right: 3px;
  font-size: 8px;
}

.d-cal__subjects__subject__remember-teacher {
  border: 1px solid #ffffff;
  padding: 0 4px;
  border-radius: 4px;
  font-size: 10px;
  display: flex;
  align-items: center;
}

.d-cal__subjects__subject__remember-teacher > span {
  margin-right: 2px;
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.35s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}

.fadeIn-enter-active, .fadeIn-leave-active {
  transition: opacity 0.25s;
}

.fadeIn-enter, .fadeIn-leave-to /* .fade-in-leave-active in <2.1.8 */
{
  opacity: 0;
}

</style>



// WEBPACK FOOTER //
// DCalendarSubjects.vue?66bae952